import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const isRemovingCard = (cardId: OLO.CreditCards.CreditCardId) =>
    createSelector(creditCardsState, (creditCards) => creditCards.remove.isRemoving && creditCards.remove.id === cardId);
